import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Button,
} from "@headlessui/react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const getOverlayWidth = (size) => {
  var overlayWidth;

  switch (size) {
    case "small":
      overlayWidth = "xl";
      break;
    case "medium":
      overlayWidth = "2xl";
      break;
    case "large":
      overlayWidth = "3xl";
      break;
    default:
      overlayWidth = size;
  }

  return overlayWidth;
};

type SideOverlayProps = {
  children: React.ReactNode;
  onClose: Function;
  show: boolean;
  title?: string;
  size?: "small" | "medium" | "large" | "5xl" | "7xl";
  buttontitle?: string;
  direction?: "right" | "bottom";
  fullRightPane?: boolean;
  flush?: boolean;
};

export const SideOverlay = (props: SideOverlayProps) => {
  const {
    children,
    onClose,
    show,
    title,

    buttontitle = "",
    size = "small",
    fullRightPane = false,
    flush = false,
  } = props;
  return (
    <>
      <Dialog open={show} onClose={() => {}} className="relative z-[999]">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex">
              <DialogPanel
                transition
                className={`pointer-events-auto w-screen max-w-${getOverlayWidth(
                  size
                )} transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700 m-0`}
              >
                <div className="flex h-full flex-col bg-gray-50 shadow-xl rounded-l-xl">
                  <div className="px-5 py-4 border-b border-gray-200">
                    <div className="flex justify-between items-center">
                      <DialogTitle className="text-lg font-semibold text-gray-900">
                        {title}
                      </DialogTitle>

                      <IconButton
                        onClick={() => onClose()}
                        sx={{
                          border: "1px solid #E5E7EB",
                          padding: "4px",
                        }}
                        size={"small"}
                      >
                        <CloseIcon className="text-gray-600" fontSize="small" />
                      </IconButton>
                    </div>
                  </div>
                  <div
                    className={
                      flush
                        ? "flex-1 min-h-0 overflow-hidden"
                        : "flex-1 px-5 py-4 overflow-y-auto overflow-x-hidden"
                    }
                  >
                    {children}
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
